import single_customer_view_img from "../assets/single_customer_view_img.png";
import business_analytics_img from "../assets/business_analytics_img.png";
import customer_analytics_img from "../assets/customer_analytics_img.png";
import marketing_analytics_img from "../assets/marketing_analytics_img.png";
import subscription_analytics_img from "../assets/subscription_analytics_img.png";
import personalise_img from "../assets/personalise_img.png";




export const WHY_DISTIL = [
    {
        title: "Why Distil.ai? ",
        subTitle: "Distil allows you to trust your data and helps you speak to your customers in a uniquely personal way."
    },
    {
        title: "What do our Customers say?",
        subTitle: "Testimonials and success stories Second line as needed"
    },
    {
        title: "Use Cases",
        subTitle: "Key ways Customer data can be put to use within your business.",
    },
    {
        title: "What is a Customer Data Platform?",
        subTitle: "What is Distil and how can data help grow your business."
    }
]
export const  RESOURCES = [
    {
        title: "Resources",
        subTitle: "Distil allows you to trust your data and helps you speak to your customers in a uniquely personal way.",
    },
    {
        title: "Blog",
        subTitle: "Data distiled into handy bite sized chunks of easily digestable daily nuggets."
    },
    {
        title: "Service Updates",
        subTitle: "Updates on the Distil service, including new features and service status."
    },
    {
        title: "Request Help",
        subTitle: "Open a ticket and request to speak to one of our experts."
    },
    {
        title: "Setup and User Guide",
        subTitle: "All you need to know to setup and use Distil.ai"
    },
    {
        title: "Practical Examples and Walk-Throughs",
        subTitle: "Complete end-to-end walk-throughs showing you how to use Distil and our catalogue of partner integrations to deliver on your data dreams."
    }
]
export const GOALS_SIDEPANEL = [

    {   single_customer_view: {
            color_1: "#ffffff",
            color_2: "#9FCE1D",
            arrow_color: "black",
            title_color: "#9FCE1D",
            description_color: "#2E2E2E",
            title: "How can I view and segment my customer data?",
            description: "The Single Customer View is where the magic happens. Every bit of data from every part of your business is drawn together and segmented using AI. Customers can be analysed as a whole, as individuals or in groups to reveal previously hidden traits and patterns and the results are plugged into your existing messaging tools for fast results.",
            image: single_customer_view_img
        },
        business_analytics: {
            color_1: "#ffffff",
            color_2: "#0A83C4",
            arrow_color: "black",
            title_color: "#0A83C4",
            description_color: "#2E2E2E",
            title: "What is the best way to analyse my data?",
            description: "Bring order to your untapped data and turn it into a vital resource, without the hassle. Automate KPI reporting, uncover and explore sophisticated Customer and Product Insights with Distil’s suite of tools.",
            image: business_analytics_img
        },
        customer_analytics: {
            color_1: "#EFA245",
            color_2: "#EFA245",
            arrow_color: "white",
            title_color: "#FFFFFF",
            description_color: "#FFFFFF",
            title: "What are my customers really like?",
            description: `Your customers are so much more than just a big list of names and numbers. Some can’t get enough of your product while others are at risk of unsubscribing for good. Some are asking for a particular gap in your product portfolio to be filled, while others are just passively browsing. 
            
Distil uses AI to tell you who’s who. It combs through your customer data and suggests how best to segment them. 
            
Apply these powerful analytics to your entire database, a particular segment or even an individual customer.`,
            image: customer_analytics_img
        },
        marketing_analytics: {
            color_1: "#F05A51",
            color_2: "#F05A51",
            arrow_color: "white",
            title_color: "#FFFFFF",
            description_color: "#FFFFFF",
            title: "Is my marketing hitting the mark?",
            description: `Let your data reveal how effective your marketing campaigns and channels already are and how to make them even better. 
            
A customer’s road from first encounter to final click can be long and winding, or short and sweet. So why just measure the final step? 
            
Distil’s Channel Attribution assesses the impact of each channel for different customer segments. So you’ll know which channels to increase investment in and which need to be downgraded or withdrawn from the mix altogether. `,
            image: marketing_analytics_img
        },
        subscription_analytics: {
            color_1: "#5A3D7F",
            color_2: "#ffffff",
            arrow_color: "white",
            title_color: "#FFFFFF",
            description_color: "#2E2E2E",
            title: "How can you turn shoppers into subscribers?",
            description: `Growing subscriptions and building loyalty are key to succeeding online. 
            
Distil helps you drive acquisition by identifying the products and plans that will enable you to attract the highest-value subscribers. 
            
Discover how to refine your product-market fit to spark customer loyalty and build and grow a successful subscription program.`,
            image: subscription_analytics_img
        },
        personalise: {
            color_1: "#DDB1CD",
            color_2: "#DDB1CD",
            arrow_color: "white",
            title_color: "#FFFFFF",
            description_color: "#FFFFFF",
            title: "How can you treat customers as individuals?",
            description: `Distil’s Personalisation package enables you to fast track your communications and become even more relevant to each one of your customers. 
            
Carefully-refined algorithms reveal what type of recommendations are suitable for each customer and segment. 
            
Distil’s Data Activation connects seamlessly to your existing tools, enabling personalised content distribution across email, SMS, on-platform and other customer touchpoints.`,
            image: personalise_img
        },
    }
]
export const GOALS_DESCRIPTION = [
    {
        color: "#5A3D7F",
        titleDescription: {title: "What is the best way to analyse my data?",
            description: "The data you need, when you need it.  Every business has a mountain of untapped data, a powerful source of information. Can you turn this chaos into order and harness your customer data? Distil fast tracks your data into a resource that suits you, without the hassle. Automate KPI reporting, uncover and explore sophisticated Customer and Product Insights."},
        descriptionBlocks: [{title: "BI portal",
            description: "Always wanted to equip your whole team with data and reports that they need but have the question of how and where to start on your mind... so much data, so many tools, so many options.  Distil BI portal was created to give you the Analytics set up your growing business dictates. Distil allows you to drag and drop your data in a supported analytical environment. Explore, automate, share and extend."},
        {title: "Data Warehouse",
            description: "Sometimes you’ve just got to get your hands dirty! Sometimes writing your SQL queries is the only way to interrogate those data sets deeper.  With Distil SQL Analytical Data Warehouse you can dive into your data on a very granular level.  \n" +
                "We get your data into the hands of those that need it, and can provide a fully managed SQL Data Warehouse or deploy directly into your existing in-house setup. "}]
    },
    {
        color: "#ECAA42",
        titleDescription: {title: "Is our marketing hitting the mark?", description: "Let your data reveal how effective your marketing campaigns and channels already are and how to make them even better. See how many customers they are bringing in, how valuable they are and what ROI you’re getting from each campaign."},
        descriptionBlocks: [{title: "Channel Attribution", description: "Your marketing messages reach your customers in a variety of different ways. But which are the most effective? And which are under performing? \n" +
                "Distil’s Channel Attribution tool assesses the impact of each part of every marketing campaign, so you know which channels to increase investment in and which need to be downgraded or withdrawn from the mix altogether. \n" +
                "The power is this view across each and every segment."}]
    }
]

export const ONE_GOAL_HELP_TEXT = "There’s a lot you can do with data from this platform";
export const MORE_GOALS_HELP_TEXT = "There’s a lot you can do with data from these platforms together";

export const MISSING_INTEGRATION_DESCRIPTION = "At Distil we are dedicated to making sure our platforms works with all the tools you need it to.We add new Integrations every month. Please let us know about any platforms that we are missing so we can get them added to Distil.ai."
export const MISSING_INTEGRATION_DESCRIPTION_SUBMIT = `Thank you for letting us know about the missing Integration. We appreciate you taking the time. 

If you asked us to get in touch one of our support team will contact you shortly.`

export const daySeconds = 60*60*24;
export const thirtyDaySeconds = daySeconds*30;

export const noOptionsMessage = "Integration Not Found!"

export const siteRegexp = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;
export const emailRegexp = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;

// ------ side panel types -----
export const DESCRIPTION_TYPE = "type-description"
export const MISSING_INTEGRATION_TYPE = "type-missing-integration-form"
export const SUBMIT_RESULT_TYPE = "type-submit-result"

// -------- Validation errors -----
export const REQUIRED = "Required";
export const EMAIL_INVALID = "Email must be valid!";
export const URL_INVALID = "Integration site url must be valid!";
